import React from "react";
import Stars from "~/common/Stars";

export interface HeaderProps {
  itemNumber: string;
  productLink: string;
  vendorItemNumber?: string;
  name: string;
  reviews: {
    rating: number;
    count: number;
  };
}

const getEncodedItemNumber = (itemNumber: string) => {
  if (itemNumber) {
    // Forward-slash is not one of the chars that is automatically encoded/decoded for reviews links
    return itemNumber.toUpperCase().replace("/", "*");
  }

  return itemNumber;
};

const Header = ({
  itemNumber,
  productLink,
  vendorItemNumber,
  name,
  reviews,
}: HeaderProps) => {
  return (
    <div className="mb-3">
      <h1 className="mb-0 text-base leading-[18px] md:text-3xl md:leading-[35px] page-header order-none font-semibold">
        {name}
      </h1>
      <div className="text-sm-1/2 leading-none flex items-center order-none gap-2.5">
        {reviews.count > 0 && (
          <span className="gap-1 items-center hidden xs:flex">
            <Stars rating={reviews.rating} />
            <a
              className="font-semibold leading-[13px] text-[13px] flex items-center border-0 text-green-500 hover:text-green-700 p-0 bg-transparent cursor-pointer"
              href={`/product-reviews/${getEncodedItemNumber(itemNumber)}.html`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {reviews.count > 0 &&
                `Read ${reviews.count} ${reviews.count === 1 ? "review" : "reviews"}`}
            </a>
          </span>
        )}
        <span className="item-number drop-shadow-[0_1px_0_#fff]">
          <span className="sr-only">Item number&nbsp; </span>
          <span aria-hidden="true">Item #:&nbsp;</span>
          <a
            href={productLink}
            className="uppercase text-[#3B4238] hover:text-green-700"
          >
            {itemNumber}
          </a>
        </span>
        {vendorItemNumber && (
          <span className="uppercase text-[13px] leading-[13px]">
            Manufacturer Item #: {vendorItemNumber}
          </span>
        )}
      </div>
    </div>
  );
};

export default Header;
